import React from 'react'
import { Transformation } from 'cloudinary-react'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

const MImageCarousel = ({ data }) => {
  const { headline, image } = data || {}
  if (!image || image.length === 0) {
    return null
  }

  return (
    <Section
      baseClass="m-ImageCarousel"
      className={data.layout === 'umbrella-branding' ? 'm-ImageCarousel--dachmarke' : ''}
      defaultPaddingTop="small"
      data={data}
    >
      <div className="m-ImageCarousel-wrapper">
        <div className="m-ImageCarousel-container">
          {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-ImageCarousel-headline" />}
          <div className="m-ImageCarousel-carousel">
            <div
              className="dfb-Slider m-ImageCarousel-slider"
              data-transition="slide"
              data-indicators
              data-loop="false"
              data-drag
              data-controls
              role="region"
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">
                  {image.length &&
                    image.map((item, index) => (
                      <li key={`slide-${index}`} className="dfb-Slider-slideItem">
                        <figure className="m-ImageCarousel-figure">
                          <DfbImage image={item} aspect_ratio="16:9">
                            <Transformation
                              crop="fill"
                              gravity="faces:center"
                              width="1246"
                              height="700"
                              quality="auto"
                              fetchFormat="auto"
                            />
                          </DfbImage>
                          {(item.description || item.copyright) && (
                            <figcaption className="m-ImageCarousel-figcaption">
                              {item.description} {item.copyright}
                            </figcaption>
                          )}
                        </figure>
                      </li>
                    ))}
                </ul>
              </div>
              <ul className="dfb-Slider-controls">
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                  <DfbButton tagName="button" icon_type="Dropdown Left" add_class="dfb-Slider-control dfb-Slider-control--previous" />
                </li>
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                  <DfbButton tagName="button" icon_type="Dropdown Right" add_class="dfb-Slider-control dfb-Slider-control--next" />
                </li>
              </ul>
            </div>
            <div className="m-ImageCarousel-navigation">
              {image.length > 1 && image.map((_, index) => <div className="m-ImageCarousel-navigation-dot" key={`nav-${index}`}></div>)}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MImageCarousel
